<template>
  <div class="visitor-over-view">
    <div class="visitor-over-view-line" style="margin: 40px 0;padding: 0 40px;">
<!--      <div class="visitor-person-count-box">-->
<!--        <div class="visitor-person-count">{{visitorDeviceCount}}</div>-->
<!--        <div class="visitor-person-tip">访客机数量</div>-->
<!--      </div>-->
<!--      <div class="visitor-person-count-box" style="background-color: #ED7D31;">-->
<!--        <div class="visitor-person-count">{{bookingPersonCount}}</div>-->
<!--        <div class="visitor-person-tip">总预约人数</div>-->
<!--      </div>-->
<!--      <div class="visitor-person-count-box" style="background-color: #92D050;">-->
<!--        <div class="visitor-person-count">{{registerPersonCount}}</div>-->
<!--        <div class="visitor-person-tip">总登记人数</div>-->
<!--      </div>-->
      <div class="visitor-person-count-box" style="background:linear-gradient(#12C9E4, #12C9E499);">
        <i class="el-icon-damai-jubutianchongwuduandian-"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{visitorDeviceCount}}</div>
          <div class="visitor-person-tip">访客机数量</div>
        </div>
      </div>
      <div class="visitor-person-count-box" style="background:linear-gradient(#ED7D31, #ED7D3199);">
        <i class="el-icon-damai-yuyue1"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{bookingPersonCount}}</div>
          <div class="visitor-person-tip">总预约人数</div>
        </div>
      </div>
      <div class="visitor-person-count-box" style="background:linear-gradient(#92D050, #92D05099);">
        <i class="el-icon-damai-dengji"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{registerPersonCount}}</div>
          <div class="visitor-person-tip">总登记人数</div>
        </div>
      </div>
    </div>

    <div class="visitor-over-view-line" style="height: 300px;margin: 30px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getVisitorRegisterRecordStatictics" />
      <common-line style="z-index: 1000" lineId='visitorRegisterRecordLine' :height='"280px"' :lineTitle='visitorRegisterRecordTitle' :legendData="visitorRegisterRecordLegendData" :xAxis="visitorRegisterRecordXAxis" :yAxis='visitorRegisterRecordYAxis' :series='visitorRegisterRecordSeries' />
    </div>

    <div class="finance-over-view-line" style="height: 300px;margin: 50px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getVisitorBookingRecordStatictics" />
      <common-line style="z-index: 1000" lineId='visitorBookingRecordLine' :height='"280px"' :lineTitle='visitorBookingRecordTitle' :legendData="visitorBookingRecordLegendData" :xAxis="visitorBookingRecordXAxis" :yAxis='visitorBookingRecordYAxis' :series='visitorBookingRecordSeries' />
    </div>
  </div>
</template>

<script>
  import {api} from '../../api/Visitor'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

  export default {
    components: {ChartTimeSelect, CommonLine},
    name: 'visitor-over-view',
    data () {
      return {
        visitorDeviceCount: 0,
        bookingPersonCount: 0,
        registerPersonCount: 0,

        visitorRegisterRecordRadio: false,
        visitorRegisterRecordTitle: '登记统计',
        visitorRegisterRecordLegendData: [],
        visitorRegisterRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        visitorRegisterRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            splitLine: {
              show: false
            },
          }
        ],
        visitorRegisterRecordSeries: [],

        visitorBookingRecordRadio: false,
        visitorBookingRecordTitle: '预约统计',
        visitorBookingRecordLegendData: [],
        visitorBookingRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        visitorBookingRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            splitLine: {
              show: false
            },
          }
        ],
        visitorBookingRecordSeries: [],
      }
    },
    mounted () {
      this.getVisitorOverview()
    },
    methods: {
      getVisitorOverview () {
        this.$axios.get(api.getVisitorOverview, {})
          .then(res => {
            let data = res.data.data
            this.visitorDeviceCount = data.visitorDeviceCount
            this.bookingPersonCount = data.bookingPersonCount
            this.registerPersonCount = data.registerPersonCount
          })
          .catch(errorHandler('获取数据失败'))
      },

      getVisitorRegisterRecordStatictics (type, startTime, endTime) {
        this.$axios.post(`${api.getVisitorRegisterRecordStatictics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
            let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.count)
              if (type === 1) {
                let dateArr = v.date.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.date)
              }
            })
            this.visitorRegisterRecordXAxis.data = xData
            this.visitorRegisterRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '统计',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      getVisitorBookingRecordStatictics (type, startTime, endTime) {
        this.$axios.post(`${api.getVisitorBookingRecordStatictics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
            let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.count)
              if (type === 1) {
                let dateArr = v.date.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.date)
              }
            })
            this.visitorBookingRecordXAxis.data = xData
            this.visitorBookingRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '统计',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      }
    },

    watch: {}
  }
</script>

<style lang="less">
  .visitor-over-view {
    padding: 10px 2%;
    .visitor-over-view-line {
      display: flex;
      justify-content: space-between;
      .visitor-person-count-box {
        width: 30%;
        height: 160px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
        i {
          width: 30%;
          font-size: 48px;
        }
        .visitor-person-count-box-info {
          width: 70%;
          text-align: left;
          .visitor-person-count {
            font-size: 36px;
            font-weight: 600;
            word-wrap:break-word;
          }
          .visitor-person-tip {
            font-size: 16px;
          }
        }
      }
      .visitor-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .visitor-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorOverView/VisitorOverView.vue